let config = {};

export const getConfig = () => config;
export const setConfig = (value) => { config = value; };

let isEditingDates = false;

export const getIsEditingDates = () => isEditingDates;
export const setIsEditingDates = (value) => { isEditingDates = value; };
